import React from 'react';
import { RuleScope } from '../../types/commission';
const scopeStyles: Record<RuleScope, string> = {
  Employee: 'border-[#D9C9F2] bg-sf-purple-light text-sf-purple',
  Branch: 'border-[#B0CDF5] bg-sf-blue-light text-sf-blue-dark',
  'Comp Type': 'border-[#9EDBD6] bg-[#E6F7F6] text-[#056764]',
  Default: 'border-sf-border-strong bg-white text-[#444444]'
};
export function ScopeBadge({
  scope
}: {
  scope: RuleScope;
}) {
  return <span className={`inline-flex items-center rounded-sm border px-1.5 text-[11px] font-semibold leading-[18px] ${scopeStyles[scope]}`} data-id="element-892" data-mp="vz3pyh15vdxw">
      {scope}
    </span>;
}